import AjaxLoadedWebsiteModal from "modal/AjaxLoadedWebsiteModal";
import Questionnaire from "../Questionnaire";

export default class QuestionnaireModal extends AjaxLoadedWebsiteModal {
    constructor() {
        super('/apprenticeships/apprentices/questionnaire/', '.js-container');
    }

    handleContent($elem) {
        this.$modal.find(".modal__content").html($elem);

        let questionnaire = new Questionnaire($elem);

        questionnaire.on('questionnaire.cancel', () => {
            this.close();
        });

        objectFitPolyfill();
    }
}